export default __webpack_public_path__ + "static/media/img-0181-ireland-full-face.d9657e65.png";